var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{class:_vm.prefix ? _vm.prefix+_vm.name : 'fas fa-'+_vm.name,style:(("font-size: " + _vm.size + "; " + _vm.styleCss))})}
var staticRenderFns = []

export { render, staticRenderFns }